import billLogApi from '@/api/billLog/billLogApi'

export default {
    name: 'bill-log-mail-check',
    mixins: [],
    extends: {},
    components: {},
    props: ['randomCode'],
    data() {
        return {
            verify: true,
            verifyCode: ''
        };
    },
    computed: {

    },
    watch: {},
    created() {

    },
    mounted() {
        
    },
    updated() {},
    beforeDestroy() {},
    methods: {
        async checkMailVerifyCode() {
            let valid = await this.$validator.validate();
            if (valid) {
                this.verify = await billLogApi.checkMailVerifyCode(this.verifyCode, this.randomCode);
                // 比對結果錯誤, 前端顯示密碼錯誤
                if (this.verify) {
                    this.$router.push({ name: 'bill-log-mail-result', params: { Msg: '我們已收到您的申請，系統將在1小時內處理您的申請。處理完成後，明細帳單將每月隨帳單固定寄送給您' } });
                }
            }
        }
    },
};


// WEBPACK FOOTER //
// ./src/components/billLog/billLogMailCheck.js